import {
    HttpResponse,
    GroupModel,
    QueryModel,
    RequestParams,
    GroupModelIEnumerableApiResultSuccess,
    GroupModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";
import {CrudPartialUpdatePatch} from '@/libs/core/+state/models/crud-partial-update-patch';

export class GroupsDataService implements CrudService<GroupModel, GroupModel> {
    getAll(query: CrudDataQuery<GroupModel>): Promise<CrudEnumerableResponse<GroupModel>> {
        return ApiService.api.getGroupBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<GroupModel>): Promise<CrudEnumerableResponse<GroupModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<GroupModel>> {
        return ApiService.api.getGroupById(id, params);
    }

    create(item: GroupModel, params?: RequestParams): Promise<CrudResponse<GroupModel>> {
        return ApiService.api.insertGroup(item, params);
    }

    update(item: GroupModel, params?: RequestParams): Promise<GroupModel> {
        return ApiService.api.updateGroup(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<GroupModel> {
        return ApiService.api.patchGroup(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<GroupModel>): Promise<CrudEnumerableResponse<GroupModel>> {
        return ApiService.api.deleteGroups(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationGroup(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<GroupModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: GroupModel, params?: RequestParams): Promise<CrudResponse<GroupModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getGroupGroupped(query, params);
    }

}
